module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('ul', {
    staticClass: "item list-box"
  }, _vm._l((_vm.navs), function(item, index) {
    return _c('li', {
      class: [_vm.activeIndex === index ? 'active' : ''],
      on: {
        "click": function($event) {
          _vm.goIndex(index)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.text))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "item del-html",
    domProps: {
      "innerHTML": _vm._s(_vm.delHtml)
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-left": "255px"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/sign/add/2006"
    }
  }, [_c('div', {
    staticClass: "reg",
    staticStyle: {
      "margin-right": "40px"
    }
  }, [_vm._v("\n        Register\n      ")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/home_en/2006/paper/en"
    }
  }, [_c('div', {
    staticClass: "reg",
    staticStyle: {
      "margin-left": "40px"
    }
  }, [_vm._v("\n        Submit\n      ")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ff679404"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tiantan/ims.vue
// module id = 831
// module chunks = 10